const LogoDim = ({ width, height, color }) => {
  return (
    <svg
      width={width ? width : "263"}
      height={height ? height : "608"}
      viewBox="0 0 263 608"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M241.647 611C-106.581 351.824 370.787 352.336 233.743 0C254.961 270.864 -91.7699 533.281 135.224 97.1696C95.7143 133.68 61.3276 175.626 33.0432 221.81C-73.3807 406.935 99.0277 530.807 241.897 610.659L241.647 611ZM247.555 609.379C331.929 510.247 508.914 429.116 385.599 123.104C567.576 332.714 475.298 502.484 247.555 609.294V609.379ZM229.915 566.212C80.1394 387.058 365.046 355.066 323.192 74.7328C445.093 374.858 179.407 324.183 229.915 566.126V566.212Z"
        fill={color ? color : "#F8F8F8"}
      />
    </svg>
  );
};

export default LogoDim;

<svg
  width="263"
  height="608"
  viewBox="0 0 263 608"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>

</svg>;
